export default "/images/card1.jpg?13da4eee6e36d869482ba410de3e4c84";